import { ref, watch, type Ref } from 'vue'

import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'

export function useSearch(
    page: Readonly<Ref<number>>,
    getRoutePage: (page: number) => ButtonRouteRelative
): { search: Ref<string> } {
    const { routerPush } = useRouterNavigation()
    const search = ref('')

    watch(search, () => {
        if (page.value === 1) {
            return
        }

        routerPush(getRoutePage(1))
    })

    return { search }
}
